module.exports = __webpack_public_path__ + "45b6b4ea5afa9641ff34de88d14a3026.jpg";